/* This is file is used for config that are  environment specific, the right object
 is chosen based on global variable (ENV_VAR) at run time. The Var is referenced in
 app.component and set in a service. The global variable is set in env.js, imported in index.html
*/
declare var ENV_PORTAL;
const ENV_PORTAL_DOMAIN = (ENV_PORTAL === 'fnabc') ? 'FN' : 'ABC';
export const ENV = {
  'mock': {
    useMock: true,
    // Not Used URl
    viewHeaders: 'restservices/sapmp/v1/profile/viewHeaders',
    updateProfile: 'restservices/sapmp/v1/profile/updateProfile',
    validateUser: 'restservices/sapmp/v1/profile/validateUser',
    samsungValidate: 'restservices/v1/sapmp/accountmanagement/samsung/validate',
    appleOrgValidate: 'restservices/v1/sapmp/accountmanagement/apple/validate',
    zteIdValidate: 'restservices/v1/sapmp/accountmanagement/google/validate',
    tranIdValidate: 'restservices/v1/sapmp/accountmanagement/apple/checkTransactionStatus',
    productConfiguratorDetails: 'assets/mock/productConfigurator.json',
    fandetails: 'assets/mock/fan.json',
    cartUrl: 'assets/mock/cartService.json',
    bandetails: 'restservices/sapmp/v1/checkout/billing/getBansByFan/',
    ctndetails: 'restservices/sapmp/v1/checkout/billing/getCtnsByBan/',
    configurationUrl: 'assets/mock/configurations.json',
    validateCartUrl: 'restservices/sapmp/v0.5/cart/validate/',
    gridDataUrl: 'assets/mock/mockgriddata.json',
    prodLicense: 'assets/mock/productlisence.json',
    createUserUrl: 'assets/mock/createUser.json',
    fivegEnrollmentUrl: 'restservices/addp/v1/account/5genrollment/request',
    homePageUrl: 'assets/cms/homePage.json',
    homePageFirstNetUrl: 'assets/cms/homePageFirstNet.json',
    homePageCms: 'restservices/cms/v1/document/home',
    contactdetails: 'assets/cms/contact.json',
    fncontactdetails: 'assets/cms/contact_fn.json',
    xmlUrl: 'assets/xml/premierxml.xml',

    // Catalog
    catalogServiceUrl: 'restservices/sapmp/v1/catalog/productDetails/products/' + ENV_PORTAL_DOMAIN + '/',
    // catalogServiceUrl: 'restservices/sapmp/v1/catalog/productDetails/products/',
    catalogColumnCount: '3', // TODO: Need to confirm with developer
    pricingupdate: 'restservices/sapmp/v1/catalog/products/priceDetails/',
    cartServiceUrl: 'restservices/sapmp/v1/cart/addCart',
    productSpecificationUrl: 'restservices/sapmp/v1/catalog/products/configurations',
    productTncUrl: 'restservices/sapmp/v1/catalog/products/tnc/' + ENV_PORTAL_DOMAIN + '/',
    changeProductUrl: 'restservices/sapmp/v1/catalog/products/priceDetails/expressCheckout',
    getPricingUpdateForDCMcode: 'restservices/sapmp/v1/catalog/products/priceDetails/manageProduct',
    catalogEfotaForm: 'restservices/edit/v1/efotaenrollment/',
    // Subcription Service
    getBanUrl: 'restservices/sapmp/v1/company/accountList/',
    getCtnUrl: 'restservices/sapmp/v1/company/subscriptionList/',

    subscriptionUrl: 'restservices/sapmp/v1/companies/{companyid}/inventory/service?serviceType=browseProduct',
    manageLicensesUrl: 'restservices/sapmp/v1/companies/{companyid}/inventory/service',
    setUpdateUrl: 'restservices/sapmp/v1/companies/inventory/service/',
    ValidateChangeProduct: 'restservices/sapmp/v1/companies/{companyid}/inventory/service?serviceType=changeProduct&billingClientId=',
    premierUrl: 'restservices/sapmp/v1/premier/premierRedirection/',
    addUserUrl: 'restservices/sapmp/v1/companies/{companyid}/employees/addUser',
    bulkAssignUnAssignUrl: 'restservices/sapmp/v1/companies/',
    ctnValidationUrl: 'restservices/sapmp/v1/companies/{companyid}/inventory/service',
    permissionUrl: 'restservices/sapmp/v1/permissions/',
    tokenGenerationUrl: 'restservices/sapmp/v1/profile/tokengeneration/',
    userServiceUrl: 'restservices/sapmp/v1/user/',
    authTokenServiceUrl: 'restservices/sapmp/v1/user/login/',
    submitConfirmOrder: 'restservices/sapmp/v1/cart/order/',
    cspGroupValidationUrl: 'restservices/sapmp/v0.5/user/validateCSPGroup/',
    loggerServiceUrl: 'restservices/sapmp/v0.5/catalog/products/logging/',
    timeOut: '8000',
    getUserInfo: 'assets/mock/users.json',
    userSummary: 'assets/mock/usersummary-',
    singleProductUrl: 'restservices/sapmp/v1/companies/',
    userEdit: 'restservices/sapmp/v1/companies/',
    getAssignUnassignProductDetails: 'api/v1/companies/',
    userRemove: 'restservices/sapmp/v1/companies/',
    getManageUserCtnUrl: 'restservices/sapmp/v1/companies/',
    mockGridDataUrl: 'assets/mock/mock-griddata-page.json',
    getUserSearch: 'restservices/sapmp/v1/companies/',
    productLicenseUrl: 'restservices/sapmp/v1/companies/',
    unAssignUrl: 'restservices/sapmp/v1/companies/',
    profilePerm: 'assets/mock/profilePerm/newProfileData.json',
    profilePermAdmin: 'restservices/sapmp/v1/profile/profileAndPermsInfoAdmin',
    // profilePerm: 'restservices/sapmp/v1/profile/profileAndPermsInfo',
    bulkUploadServiceUrl: 'restservices/sapmp/v1/company/file/upload',
    getProductAndPriceDetailsFromCSI: 'restservices/sapmp/v1/company/inquireMobileProductsOrder',
    getStatsTops: 'restservices/sapmp/v1/companies/{companyid}/top/{offercount}?breakdown=false',
    getStatsUsers: 'restservices/sapmp/v1/companies/{companyid}/stats',
    profilesPageSize: 100,
    ctnPageSize: 45,
    getStatsReport: 'restservices/sapmp/v1/company/file/download/userSummaryReport',
    getPricingForOwnedProduct: 'restservices/sapmp/v1/company/inquireMobileProductsOrder',
    bulkReviewUrl: 'restservices/sapmp/v1/companies/{companyId}/employees/bulk',
    getProductFanCtnDetails: 'assets/mock/manage_users.json',
    searchUsersUrl: 'restservices/sapmp/v1/companies/',
    cartOrderUrl: 'restservices/sapmp/v1/cart/order/modify/modifyOrder',
    changeCartOrderUrl: 'restservices/sapmp/v1/cart/order/',
    tokenRefresh: 'restservices/sapmp/v1/profile/refresh',
    haloAuthenticateUrl: 'restservices/sapmp/v1/profile/verifylogin',
    validateFanUrl: 'restservices/sapmp/v1/cart/addCart',
    priceDetailUrl: 'restservices/sapmp/v1/catalog/products/modifyProduct/priceDetails',
    WelcomeUrl: 'assets/contents/Welcome/welcome.json',
    WelcomeSignupUrl: 'restservices/v1/sapmp/accountmanagement/signup',
    initialUrl: 'assets/contents/initailsignup/initialsignup.json',
    getGoogleId: 'assets/mock/productselection/googleVal.json',
    // getSamsungId: 'assets/mock/productselection/samsungVal.json',
    getSamsungId: 'restservices/v1/sapmp/accountmanagement/samsung/validate',
    mdmDetails: 'assets/mock/productselection/initialRevisedDetails.json',
    enrollDetails: 'assets/contents/enrollmentTool/enrollmentTool.json',
    faqServiceUrl: 'restservices/addp/v1/faqservice/getAll',
    faqServiceUrlMock: './../../../assets/mock/Faq/faqService.json',
    settingsFormConfig: 'assets/mock/formConfig.json',
    getFANList: 'restservices/addp/v1/account/summary',
    getprofileList: 'restservices/addp/v1/account/settings',
    getAppList: 'restservices/addp/v1/account/applications',
    getTNC: 'restservices/addp/v1/account/configuration/tnc',
    submitSignup: 'restservices/addp/v1/cart/signup-setup',
    submitGroup : 'restservices/addp/v1/dashboard/groupingImeis',
    updateGroupName: 'restservices/addp/v1/dashboard/updateGroup',
    getGroupDevices: 'restservices/addp/v1/dashboard/getDevicesGroups',
    getManageGroupsUrl:'restservices/addp/v1/dashboard/manageGroups',
    submitSignupInProgress: 'restservices/addp/v1/cart/signupinprogress',
    submitCancelParticipation: 'restservices/addp/v1/cart/cancel',
    cancelOEMUrl: 'restservices/addp/v1/cart/canceloem',
    createProfile: 'restservices/addp/v1/account/setup',
    updateProfileName: 'restservices/addp/v1/account/profiles',
    profilePermissionUrl: 'assets/mock/getProfile_Read_NoFAN.json',

    getFANListMock: ['assets/mock/signup/accounts/initialSignupFANList.json',
      'assets/mock/signup/accounts/allFANList.json',
      'assets/mock/signup/accounts/newNRevisedFANList.json',
      'assets/mock/signup/accounts/onlyRevisedFANList.json',
      'assets/mock/signup/accounts/demoFANList.json'],


    profileListUrl: ['assets/mock/signup/settings/profileListLT20.json',
      'assets/mock/signup/settings/profileListGT20.json'],
    gridAppDataUrl: 'assets/mock/signup/applications/getappdetail.json',
    learnPageUrl: 'assets/mock/learnPage.json',
    getProfileUrl: 'assets/mock/getprofiledetail.json',
    profilePermMock: ['assets/mock/profilePerm/readOnly.json',
      'assets/mock/profilePerm/partial.json',
      'assets/mock/profilePerm/full.json',
      'assets/mock/profilePerm/none.json'],
    fanSignupStatusUrl: ['assets/mock/fanSignedUpStatus/all.json', 'assets/mock/fanSignedUpStatus/new.json',
      'assets/mock/fanSignedUpStatus/some.json',
      'assets/mock/fanSignedUpStatus/none.json'
    ],
    getProfileStatusUrl: 'restservices/addp/v1/dashboard/deviceinventory',
    getProfileStatusMockUrl: 'assets/mock/deviceInventory/getProfileStatus.json',
    deviceInventoryDetailsUrl: 'assets/mock/deviceInventory/deviceInventoryDetails.json',
    manageInventoryPageUrl: 'assets/mock/manageInventory/manageInventory.json',
    deviceDeploymentSummaryUrl: 'assets/mock/deployment_status_list.json',
    companyFanStatusUrl: 'assets/mock/company_fan_status.json',
    appleCertificateUrl: 'assets/mock/appleCertificateStatus.json',
    devicesSummaryUrl: 'restservices/addp/v1/dashboard/devices',
    devicesSummaryMockUrl: 'assets/mock/devicesSummary.json',

    ctnDetailsMockUrl: 'assets/mock/manageInventory/mockCtnDetails.json',
    ctnDetailsUrl: 'restservices/addp/v1/dashboard/ctninfo',
    ctnUpdateUrl: 'restservices/addp/v1/account/ctnUpdate/request',
    ctnNumberUrl: 'assets/mock/ctnNumber/ctnNumbers.json',
    imeiNumberUrl: 'assets/mock/imeiNumber/imeiNumbers.json',
    messageFormJson: 'assets/mock/messageForm.json',
    singleFanProfileUrl: 'assets/mock/singleFanProfile/fanDetails.json',
    manyFanProfileUrl: 'assets/mock/singleFanProfile/manyFanDetails.json',
    fanProfileUrl: 'restservices/addp/v1/dashboard/profileinfo',
    sendSMSFanList: 'assets/mock/sendSMSFanMock.json',
    sendSmsMockJson: 'assets/mock/sendSmsCtnMock.json',
    mockSMSPostUrl: 'restservices/addp/v1/notifications',
    notificationClient:'restservices/addp/v1/notificationservice/efotaReportRequestEmail',
    notificationServiceForm: 'restservices/addp/v1/notificationservice/form',
    sendSMSUrl: 'restservices/addp/v1/notificationservice/manageSms',
    abridgedList: 'assets/mock/abridgedFANList.json',
    notificationsUrlMock: 'assets/mock/notifications-alerts.json',
    notificationsUrl: 'restservices/addp/v1/notification/alert/',
    createZtpAccountMock: './../../../assets/contents/signup/googleMock.json',
    createZtpAccount: 'restservices/v1/sapmp/accountmanagement/google/create',
    // samsungValidate: 'http://localhost:8080/samsung/custDetails',
    contentUrl: {
      signup: {
        accounts: 'assets/contents/signup/accounts.json',
        settings: 'assets/contents/signup/settings.json',
        applications: 'assets/contents/signup/applications.json',
        startdate: 'assets/contents/signup/startdate.json',
        review: 'assets/contents/signup/review.json',
        confirm: 'assets/contents/signup/confirm.json'
      },
      sendSMS: {
        page: 'assets/contents/sendSMS/message.json',
        modal: 'assets/contents/sendSMS/message-modal.json'
      },
      manageInventory: {
        manageInventoryPageUrl: 'assets/contents/manageInventory/manageInventory.json',
        deviceInventory: 'assets/contents/manageInventory/deviceInventory.json',
        ctnViewData: 'assets/contents/manageInventory/viewCtnPageData.json',
        deviceLockWipeDetailsUrl: 'assets/contents/manageInventory/deviceLockWipe.json',
        deviceStatusUrlMock: 'assets/contents/manageInventory/deviceLockStatus.json',
        deviceStatusUrl: 'restservices/addp/v1/device',
        getUpdatedCtnDetailsUrlMock: 'assets/contents/manageInventory/updatedCtnDetails.json'
      },
      dashboard: {
        dashboardData: 'assets/contents/dashboard/dashboardData.json'
      },
      applecertificate: {
        info: 'assets/contents/appleCertificate/info.json',
        upload: 'assets/contents/appleCertificate/upload.json'
      },
      cancelParticipation: {
        cancel: 'assets/contents/cancelParticipation/cancel/cancel.json',
        review: 'assets/contents/cancelParticipation/review/review.json',
        confirm: 'assets/contents/cancelParticipation/confirm/confirm.json',
      },

    },
    getFanStatusSummarymock: ['assets/mock/dashboard/initialSignup.json',
      'assets/mock/dashboard/signupInProgress.json',
      'assets/mock/dashboard/errorInSignup.json',
      'assets/mock/dashboard/awaitingSetup.json',
      'assets/mock/dashboard/setupInProgress.json',
      'assets/mock/dashboard/setupCompleted.json',
      'assets/mock/dashboard/deviceEnrollInProgress.json',
      'assets/mock/dashboard/deviceEnrollError.json',
      'assets/mock/dashboard/multiFanEnrolled.json',
      'assets/mock/dashboard/singleFanEnrolled.json',
      'assets/mock/dashboard/ineligibleFan.json',
      'assets/mock/dashboard/setupOemCompleted.json'
    ],
    getAppleSummaryMock: ['assets/mock/apple-certificate/notInstalled.json',
      'assets/mock/apple-certificate/installed.json',
      'assets/mock/apple-certificate/expired.json',
      'assets/mock/apple-certificate/processing.json'],
    getAppleSummary: 'restservices/addp/v1/apple/inquire',
    generateCSR: 'restservices/addp/v1/apple/csr',
    deleteAppleCertificate: 'restservices/addp/v1/apple/delete',
    uploadAppleCertificate: 'restservices/addp/v1/apple/upload',
    dashboardSummary: 'restservices/addp/v1/dashboard/accountsummary',
    triggerActiveFans: 'restservices/addp/v1/dashboard/dataload',
    deviceCountSummary: 'restservices/addp/v1/dashboard/deviceCount',
    getReportRequestUrl: 'restservices/addp/v1/report/snapshot/all',
    getReportRequestOEMUrl: 'restservices/addp/v1/report/snapshot/reportByFan',
    efotaEmailReport: 'restservices/addp/v1/report/efota/emailReportAttachment',
    efotaRetrieveReport: 'restservices/addp/v1/report/efota/retrieveReport',
    efotaUpdateReport: 'restservices/addp/v1/report/efota/updateReport',
    efotaEnrollments: 'restservices/admins/v1/query/default/efotaenrollment',
    efotaEnrollAccount: '/restservices/addp/v1/account/efota/signup',
    efotaGetReportFile: 'restservices/addp/v1/report/efota/getReportAttachment/',
    efotaChangeRequests: 'restservices/addp/v1/account/efota/getChangeRequests',
    efotaChangeRequest: 'restservices/addp/v1/account/efota/changeRequest',
    efotaAdminChangeRequests: 'restservices/admins/v1/query/default/Ticket',
    efotaDisconnectAccount : 'restservices/admins/v1/efota/disconnect/',
    efotaUpdateChangeRequest: 'restservices/admins/v1/cms/default/Ticket/',
    // tslint:disable-next-line:max-line-length
    //  'http://zld04700.vci.att.com:32309restservices/addp/v1/report/snapshot/833756412,8356412537?type=xls&email=someone@att.com&username=Tony1', //'assets/mock/mockReportSuccess.json',
    getTransactionReportRequestUrl: 'restservices/addp/v1/report/transaction/',
    //  'http://zld04700.vci.att.com:32309restservices/addp/v1/report/transaction/',
    getReportPageConfigUrl: 'assets/mock/reportPageConfig.json',

    // restservices/addp/v1/report/validate/fan?ctn=2149588808
    getCTNMock: ['assets/mock/validateCTNSuccess.json', 'assets/mock/validateCTNFailure.json'],
    getCTN: 'restservices/addp/v1/report/validate/fan',


    getCarePageConfigUrl: 'assets/mock/care/carePageConfig.json',
    submitCareSelectedParticipation: 'lic/addp/v1/Care/submit',
    getSearchFanPageConfigUrl: 'assets/mock/care/searchFanConfig.json',
    getFanSearchFanDetails:'restservices/edit/v1/efotaenrollment/',
    getFanDetails: 'restservices/admins/v1/cms/default/efotaenrollment/',
    updateEnrollStatus: 'restservices/admins/v1/efota/default/efotaenrollment/',
    getAllFanDetails:'restservices/edit/v1/efotaenrollment',
    // tokenRefresh: 'restservices/addp/v1/inquire/refresh',
    // careAuthTokenServiceUrl: 'assets/mock/care/auth.json',
    // careUserProfileUrl: 'assets/mock/care/userProfile.json',
getSupportDocument: 'restservices/addp/v1/faqservice/supportArticle/',
    // getSupportDocumentMock:['assets/mock/manageInventory/supportLock.json',
    //  'assets/mock/manageInventory/supportWipe.json',
    //  'assets/mock/manageInventory/supportLock.json'
    // ],


    careAuthTokenServiceUrlMock: 'assets/mock/care/auth.json',
    careUserProfileUrlMock: 'assets/mock/care/userProfile.json',
    careAuthTokenWithoutFanIdServiceUrlMock: 'assets/mock/care/auth.json',
    careMultiFanMock: 'assets/mock/care/multifan.json',
    careSearchFanUrlMock: 'assets/mock/care/newVerify.json',
    careUpdateEmailMock: 'assets/mock/care/updateEmail.json',

    // careAuthTokenServiceUrl: 'restservices/addp/v1/licservice/csp/authenticate/',
    careUserProfileUrl: 'restservices/addp/v1/licservice/aaf/inquire/permissions',
    careAuthTokenWithoutFanIdServiceUrl: 'restservices/addp/v1/licservice/csp/authenticate',
    careMultiFan: 'restservices/addp/v1/licservice/agreement/inquire/fans',
    careSearchFanUrl: 'restservices/addp/v1/licservice/fan/verify/',
    careUpdateEmail: 'restservices/addp/v1/licservice/customer/updateEmail',
    upgradeDeviceServiceUrl: 'service/addp/v1/fileuploadservice/upgradedevice/upload',
    // haloAuthenticateUrl: 'assets/mock/authHaloState.json'
    getuploadfiles: 'restservices/admins/v1/abm/uidetails',
    getzteuploadfiles: 'restservices/admins/v1/zte/uidetails',
    getcareabmdetails: 'restservices/admins/v1/abm/adminsOrdersUi',
    appleFeStatusUpdate: 'restservices/admins/v1/abm/appleFeStatusUpdate',
    deviceStatusUpdate: 'restservices/admins/v1/deviceStatusUpdate',
    encryptImei: 'restservices/addp/v1/dashboard/encrypt',
    getcarekmedetails: 'restservices/admins/v1/kme/adminOrdersKME',
    getkmeuidetails: 'restservices/admins/v1/kme/uidetails',
    getcareztedetails: 'restservices/admins/v1/zte/adminOrdersZTE',
    getdeviceTrackingData: 'restservices/admins/v1/tracking',
    getcareDmpWhiteistFans:'/restservices/admins/v1/query/default/DMPWhitelistFans', // dmpwhitelistfans
    saveDmpwhitelist: '/restservices/admins/v1/cms/default', 
    // getcareFeDetails: 'restservices/admins/v1/query/default/ABMOrgIDValidation', //feList
    //sendToAppleFeRequest: 'restservices/admins/v1/abm/facilitatedEnrollment',
    sendToAppleFeRequest: 'restservices/apple/abm/facilitatedEnrollment',
    getcareDeviceEnrollmentDetails: 'restservices/admins/v1/abm/adminsPendingABMTransaction',
    revisenotificationsettings: 'restservices/addp/v1/account/revisenotificationsettings',
    changeorgid:'/restservices/addp/v1/account/setup/changeorgid',
    enrollExistingDevice:'restservices/addp/v1/account/enrollexistingdevices',
    getBulkSchedulerRunTimeUrl:'restservices/admins/v1/abm/getSchedulerTriggeredDetails',
    deleteGroup: 'restservices/addp/v1/dashboard/deleteGroup',
    getInquireFanDetails: 'restservices/addp/v1/account/inquireFanDetails',
    getInquireProfile: 'restservices/addp/v1/dashboard/profilesummary',
    abmfeDepResellerId: '6FFA140',
    zteResellerId: '261789095',
    kmeResellerId: '6004067397',
    accessoriesLink: 'https://test12-www.wireless.att.com/business/shop/shop_cru_home.jsp?fromNewAccessoryPage=false&_requestid=3927',
    getLoginHistory: 'restservices/sapmp/v1/profile/loginInfo',
    logoutHistory: 'restservices/sapmp/v1/profile/logoutInfo',
    validateUserEmail:'restservices/sapmp/v1/profile/validateCustomerEmail'
  },

  'test': {
    useMock: false,
    ticketProductionUpdateURL: 'restservices/admins/v1/cms/default/Ticket',
    updateProfile: 'restservices/sapmp/v1/profile/updateProfile',
    ticketProductionURL: 'restservices/admins/v1/query/default/Ticket',
    ticketUpdateURL: 'restservices/admins/v1/cms/test/Ticket',
    ticketURL: 'restservices/admins/v1/query/test/Ticket',
    viewHeaders: 'restservices/sapmp/v1/profile/viewHeaders',
    validateUser: 'restservices/sapmp/v1/profile/validateUser',
    deviceCountSummary: 'restservices/addp/v1/dashboard/deviceCount',
    getSamsungId: 'restservices/v1/sapmp/accountmanagement/samsung/validate',
    samsungValidate: 'restservices/v1/sapmp/accountmanagement/samsung/validate',
    zteIdValidate: 'restservices/v1/sapmp/accountmanagement/google/validate',
    appleOrgValidate: 'restservices/v1/sapmp/accountmanagement/apple/validate',
    tranIdValidate: 'restservices/v1/sapmp/accountmanagement/apple/checkTransactionStatus',
    createZtpAccount: 'restservices/v1/sapmp/accountmanagement/google/create',
    mdmDetails: 'restservices/v1/sapmp/accountmanagement/product',
    fivegEnrollmentUrl: 'restservices/addp/v1/account/5genrollment/request',
    enrollDetails: 'assets/contents/enrollmentTool/enrollmentTool.json',
    productConfiguratorDetails: 'assets/mock/productConfigurator.json',
    catalogEfotaForm: 'restservices/edit/v1/efotaenrollment/',
    fandetails: 'assets/mock/fan.json',
    profilesPageSize: 100,
    ctnPageSize: 45,
    cartUrl: 'assets/mock/cartService.json',
    bandetails: 'restservices/sapmp/v1/checkout/billing/getBansByFan/',
    ctndetails: 'restservices/sapmp/v1/checkout/billing/getCtnsByBan/',
    configurationUrl: 'assets/mock/configurations.json',
    validateCartUrl: 'restservices/sapmp/v0.5/cart/validate/',
    gridDataUrl: 'assets/mock/mockgriddata.json',
    prodLicense: 'assets/mock/productlisence.json',
    createUserUrl: 'assets/mock/createUser.json',

    homePageUrl: 'assets/cms/homePage.json',
    homePageFirstNetUrl: 'assets/cms/homePageFirstNet.json',
    homePageCms: 'restservices/cms/v1/document/home',
    contactdetails: 'assets/cms/contact.json',
    fncontactdetails: 'assets/cms/contact_fn.json',
    xmlUrl: 'assets/xml/premierxml.xml',

    // Catalog
    catalogServiceUrl: 'restservices/sapmp/v1/catalog/productDetails/products/' + ENV_PORTAL_DOMAIN + '/',
    // catalogServiceUrl: 'restservices/sapmp/v1/catalog/productDetails/products/',
    catalogColumnCount: '3', // TODO: Need to confirm with developer
    pricingupdate: 'restservices/sapmp/v1/catalog/products/priceDetails/',
    cartServiceUrl: 'restservices/sapmp/v1/cart/addCart',
    productSpecificationUrl: 'restservices/sapmp/v1/catalog/products/configurations',
    productTncUrl: 'restservices/sapmp/v1/catalog/products/tnc/' + ENV_PORTAL_DOMAIN + '/',
    changeProductUrl: 'restservices/sapmp/v1/catalog/products/priceDetails/expressCheckout',
    getPricingUpdateForDCMcode: 'restservices/sapmp/v1/catalog/products/priceDetails/manageProduct',

    // Subcription Service
    getBanUrl: 'restservices/sapmp/v1/company/accountList/',
    getCtnUrl: 'restservices/sapmp/v1/company/subscriptionList/',

    subscriptionUrl: 'restservices/sapmp/v1/companies/{companyid}/inventory/service?serviceType=browseProduct',
    manageLicensesUrl: 'restservices/sapmp/v1/companies/{companyid}/inventory/service',
    setUpdateUrl: 'restservices/sapmp/v1/companies/inventory/service/',
    ValidateChangeProduct: 'restservices/sapmp/v1/companies/{companyid}/inventory/service?serviceType=changeProduct&billingClientId=',
    premierUrl: 'restservices/sapmp/v1/premier/premierRedirection/',
    addUserUrl: 'restservices/sapmp/v1/companies/{companyid}/employees/addUser',
    bulkAssignUnAssignUrl: 'restservices/sapmp/v1/companies/',
    ctnValidationUrl: 'restservices/sapmp/v1/companies/{companyid}/inventory/service',
    permissionUrl: 'restservices/sapmp/v1/permissions/',
    tokenGenerationUrl: 'restservices/sapmp/v1/profile/tokengeneration/',
    userServiceUrl: 'restservices/sapmp/v1/user/',
    authTokenServiceUrl: 'restservices/sapmp/v1/user/login/',
    submitConfirmOrder: 'restservices/sapmp/v1/cart/order/',
    cspGroupValidationUrl: 'restservices/sapmp/v0.5/user/validateCSPGroup/',
    loggerServiceUrl: 'restservices/sapmp/v0.5/catalog/products/logging/',
    timeOut: '8000',
    getUserInfo: 'assets/mock/users.json',
    userSummary: 'assets/mock/usersummary-',
    singleProductUrl: 'restservices/sapmp/v1/companies/',
    userEdit: 'restservices/sapmp/v1/companies/',
    getAssignUnassignProductDetails: 'api/v1/companies/',
    userRemove: 'restservices/sapmp/v1/companies/',
    getManageUserCtnUrl: 'restservices/sapmp/v1/companies/',
    mockGridDataUrl: 'assets/mock/mock-griddata-page.json',
    getUserSearch: 'restservices/sapmp/v1/companies/',
    productLicenseUrl: 'restservices/sapmp/v1/companies/',
    unAssignUrl: 'restservices/sapmp/v1/companies/',
    profilePerm: 'restservices/sapmp/v1/profile/profileAndPermsInfo',
    profilePermAdmin: 'restservices/sapmp/v1/profile/profileAndPermsInfoAdmin',
    bulkUploadServiceUrl: 'restservices/sapmp/v1/company/file/upload',
    getProductAndPriceDetailsFromCSI: 'restservices/sapmp/v1/company/inquireMobileProductsOrder',
    getStatsTops: 'restservices/sapmp/v1/companies/{companyid}/top/{offercount}?breakdown=false',
    getStatsUsers: 'restservices/sapmp/v1/companies/{companyid}/stats',
    getStatsReport: 'restservices/sapmp/v1/company/file/download/userSummaryReport',
    getPricingForOwnedProduct: 'restservices/sapmp/v1/company/inquireMobileProductsOrder',
    bulkReviewUrl: 'restservices/sapmp/v1/companies/{companyId}/employees/bulk',
    getProductFanCtnDetails: 'assets/mock/manage_users.json',
    searchUsersUrl: 'restservices/sapmp/v1/companies/',
    cartOrderUrl: 'restservices/sapmp/v1/cart/order/modify/modifyOrder',
    changeCartOrderUrl: 'restservices/sapmp/v1/cart/order/',
    tokenRefresh: 'restservices/sapmp/v1/profile/refresh',
    haloAuthenticateUrl: 'restservices/sapmp/v1/profile/verifylogin',
    validateFanUrl: 'restservices/sapmp/v1/cart/addCart',
    priceDetailUrl: 'restservices/sapmp/v1/catalog/products/modifyProduct/priceDetails',
    WelcomeUrl: 'assets/contents/Welcome/welcome.json',
    faqServiceUrl: 'restservices/addp/v1/faqservice/getAll',
    efotaEmailReport: 'restservices/addp/v1/report/efota/emailReportAttachment',
    efotaRetrieveReport: 'restservices/addp/v1/report/efota/retrieveReport',
    efotaUpdateReport: 'restservices/addp/v1/report/efota/updateReport',
    efotaEnrollments: 'restservices/admins/v1/query/default/efotaenrollment',
    efotaEnrollAccount: '/restservices/addp/v1/account/efota/signup',
    efotaGetReportFile: 'restservices/addp/v1/report/efota/getReportAttachment/',
    efotaChangeRequests: 'restservices/addp/v1/account/efota/getChangeRequests',
    efotaChangeRequest: 'restservices/addp/v1/account/efota/changeRequest',
    efotaAdminChangeRequests: 'restservices/admins/v1/query/default/Ticket',
    efotaDisconnectAccount : 'restservices/admins/v1/efota/disconnect/',
    efotaUpdateChangeRequest: 'restservices/admins/v1/cms/default/Ticket/',
    faqServiceUrlMock: 'assets/mock/Faq/faqService.json', 
    settingsFormConfig: 'assets/mock/formConfig.json',
    getFANList: 'restservices/addp/v1/account/summary',
    getprofileList: 'restservices/addp/v1/account/settings',
    getAppList: 'restservices/addp/v1/account/applications',
    getTNC: 'restservices/addp/v1/account/configuration/tnc',
    submitSignup: 'restservices/addp/v1/cart/signup-setup',
    submitGroup : 'restservices/addp/v1/dashboard/groupingImeis',
    updateGroupName: 'restservices/addp/v1/dashboard/updateGroup',
    getGroupDevices: 'restservices/addp/v1/dashboard/getDevicesGroups',
    getManageGroupsUrl:'restservices/addp/v1/dashboard/manageGroups',
    submitSignupInProgress: 'restservices/addp/v1/cart/signupinprogress',
    submitCancelParticipation: 'restservices/addp/v1/cart/cancel',
    cancelOEMUrl: 'restservices/addp/v1/cart/canceloem',
    createProfile: 'restservices/addp/v1/account/setup',
    updateProfileName: 'restservices/addp/v1/account/profiles',
    getFANListMock: ['assets/mock/signup/accounts/initialSignupFANList.json',
      'assets/mock/signup/accounts/allFANList.json',
      'assets/mock/signup/accounts/newNRevisedFANList.json',
      'assets/mock/signup/accounts/onlyRevisedFANList.json'],
    profilePermissionUrl: 'assets/mock/getProfile_Read_NoFAN.json',
    learnPageUrl: 'assets/mock/learnPage.json',
    profileListUrl: ['assets/mock/signup/settings/profileListLT20.json',
      'assets/mock/signup/settings/profileListGT20.json'],
    gridAppDataUrl: 'assets/mock/signup/applications/getappdetail.json',
    getProfileUrl: 'assets/mock/getprofiledetail.json',
    profilePermMock: ['assets/mock/profilePerm/readOnly.json',
      'assets/mock/profilePerm/partial.json',
      'assets/mock/profilePerm/full.json',
      'assets/mock/profilePerm/none.json'],
    fanSignupStatusUrl: ['assets/mock/fanSignedUpStatus/all.json',
      'assets/mock/fanSignedUpStatus/some.json',
      'assets/mock/fanSignedUpStatus/none.json'],
    WelcomeSignupUrl: 'restservices/v1/sapmp/accountmanagement/signup',
    initialUrl: 'assets/contents/initailsignup/initialsignup.json',
    manageInventoryPageUrl: 'assets/mock/manageInventory/manageInventory.json',
    deviceDeploymentSummaryUrl: 'assets/mock/deployment_status_list.json',
    companyFanStatusUrl: 'assets/mock/company_fan_status.json',
    appleCertificateUrl: 'assets/mock/appleCertificateStatus.json',
    devicesSummaryMockUrl: 'assets/mock/devicesSummary.json',
    devicesSummaryUrl: 'restservices/addp/v1/dashboard/devices',
    ctnDetailsMockUrl: 'assets/mock/manageInventory/mockCtnDetails.json',
    ctnDetailsUrl: 'restservices/addp/v1/dashboard/ctninfo',
    ctnUpdateUrl: 'restservices/addp/v1/account/ctnUpdate/request',
    ctnNumberUrl: 'assets/mock/ctnNumber/ctnNumbers.json',
    imeiNumberUrl: 'assets/mock/imeiNumber/imeiNumbers.json',
    messageFormJson: 'assets/mock/messageForm.json',
    fanProfileUrl: 'restservices/addp/v1/dashboard/profileinfo',
    singleFanProfileUrl: 'assets/mock/singleFanProfile/fanDetails.json',
    dashboardSummary: 'restservices/addp/v1/dashboard/accountsummary',
    triggerActiveFans: 'restservices/addp/v1/dashboard/dataload',
    manyFanProfileUrl: 'assets/mock/singleFanProfile/manyFanDetails.json',
    sendSMSFanList: 'assets/mock/sendSMSFanMock.json',
    sendSmsMockJson: 'assets/mock/sendSmsCtnMock.json',
    notificationClient:'restservices/addp/v1/notificationservice/efotaReportRequestEmail',
    notificationServiceForm: 'restservices/addp/v1/notificationservice/form',
     sendSMSUrl: 'restservices/addp/v1/notificationservice/manageSms',
    abridgedList: 'assets/mock/abridgedFANList.json',
    notificationsUrlMock: 'assets/mock/notifications-alerts.json',
    notificationsUrl: 'restservices/addp/v1/notification/alert/',
    contentUrl: {
      signup: {
        accounts: 'assets/contents/signup/accounts.json',
        settings: 'assets/contents/signup/settings.json',
        applications: 'assets/contents/signup/applications.json',
        startdate: 'assets/contents/signup/startdate.json',
        review: 'assets/contents/signup/review.json',
        confirm: 'assets/contents/signup/confirm.json'
      },
      sendSMS: {
        page: 'assets/contents/sendSMS/message.json',
        modal: 'assets/contents/sendSMS/message-modal.json'
      },
      manageInventory: {
        manageInventoryPageUrl: 'assets/contents/manageInventory/manageInventory.json',
        deviceInventory: 'assets/contents/manageInventory/deviceInventory.json',
        ctnViewData: 'assets/contents/manageInventory/viewCtnPageData.json',
        deviceLockWipeDetailsUrl: 'assets/contents/manageInventory/deviceLockWipe.json',
        deviceStatusUrlMock: 'assets/contents/manageInventory/deviceLockStatus.json',
        deviceStatusUrl: 'restservices/addp/v1/device',
        getUpdatedCtnDetailsUrlMock: 'assets/contents/manageInventory/updatedCtnDetails.json'
      },
      dashboard: {
        dashboardData: 'assets/contents/dashboard/dashboardData.json'
      },
      applecertificate: {
        info: 'assets/contents/appleCertificate/info.json',
        upload: 'assets/contents/appleCertificate/upload.json'
      },
      cancelParticipation: {
        cancel: 'assets/contents/cancelParticipation/cancel/cancel.json',
        review: 'assets/contents/cancelParticipation/review/review.json',
        confirm: 'assets/contents/cancelParticipation/confirm/confirm.json',
      }
    },
    deviceInventoryDetailsUrl: 'assets/mock/deviceInventory/deviceInventoryDetails.json',
    getProfileStatusUrl: 'restservices/addp/v1/dashboard/deviceinventory',
    getProfileStatusMockUrl: 'assets/mock/deviceInventory/getProfileStatus.json',
    getFanStatusSummarymock: ['assets/mock/dashboard/initialSignup.json',
      'assets/mock/dashboard/signupInProgress.json',
      'assets/mock/dashboard/errorInSignup.json',
      'assets/mock/dashboard/awaitingSetup.json',
      'assets/mock/dashboard/setupInProgress.json',
      'assets/mock/dashboard/setupCompleted.json',
      'assets/mock/dashboard/deviceEnrollInProgress.json',
      'assets/mock/dashboard/deviceEnrollError.json',
      'assets/mock/dashboard/multiFanEnrolled.json',
      'assets/mock/dashboard/singleFanEnrolled.json'
    ],
    getAppleSummaryMock: ['assets/mock/apple-certificate/notInstalled.json',
      'assets/mock/apple-certificate/installed.json',
      'assets/mock/apple-certificate/expired.json',
      'assets/mock/apple-certificate/processing.json'],
    getAppleSummary: 'restservices/addp/v1/apple/inquire',
    generateCSR: 'restservices/addp/v1/apple/csr',
    deleteAppleCertificate: 'restservices/addp/v1/apple/delete',
    uploadAppleCertificate: 'restservices/addp/v1/apple/upload',
    getReportRequestUrl: 'restservices/addp/v1/report/snapshot/all',
    getReportRequestOEMUrl: 'restservices/addp/v1/report/snapshot/reportByFan',
    getTransactionReportRequestUrlMock: 'assets/mock/mockReportSuccess.json',
    getTransactionReportRequestUrl: 'restservices/addp/v1/report/transaction/',
    getReportPageConfigUrl: 'assets/mock/reportPageConfig.json',
    getCTN: 'restservices/addp/v1/report/validate/fan',
    getCarePageConfigUrl: 'assets/mock/care/carePageConfig.json',
    submitCareSelectedParticipation: 'lic/addp/v1/Care/submit',
    getSearchFanPageConfigUrl: 'assets/mock/care/searchFanConfig.json',
    careUserServiceUrl: 'restservices/addp/v1/licservice/inquire/profile',
    getFanSearchFanDetails:'restservices/edit/v1/efotaenrollment/',
    getFanDetails: 'restservices/admins/v1/cms/default/efotaenrollment/',
    updateEnrollStatus: 'restservices/admins/v1/efota/default/efotaenrollment/',
    getAllFanDetails:'restservices/edit/v1/efotaenrollment',
    getSupportDocument: 'restservices/addp/v1/faqservice/supportArticle/',
    getSupportDocumentMock: ['assets/mock/manageInventory/supportLock.json',
      'assets/mock/manageInventory/supportWipe.json',
      'assets/mock/manageInventory/supportLock.json'
    ],
    careAuthTokenServiceUrlMock: 'assets/mock/care/auth.json',
    careUserProfileUrlMock: 'assets/mock/care/userProfile.json',
    careAuthTokenWithoutFanIdServiceUrlMock: 'assets/mock/care/auth.json',
    careMultiFanMock: 'assets/mock/care/multifan.json',
    careSearchFanUrlMock: 'assets/mock/care/verify.json',
    careUserProfileUrl: 'restservices/addp/v1/licservice/aaf/inquire/permissions',
    careAuthTokenWithoutFanIdServiceUrl: 'restservices/addp/v1/licservice/csp/authenticate',
    careMultiFan: 'restservices/addp/v1/licservice/agreement/inquire/fans',
    careSearchFanUrl: 'restservices/addp/v1/licservice/fan/verify/',
    careUpdateEmail: 'restservices/addp/v1/licservice/customer/updateEmail',
    getuploadfiles: 'restservices/admins/v1/abm/uidetails',
    getzteuploadfiles: 'restservices/admins/v1/zte/uidetails',
    getcareabmdetails: 'restservices/admins/v1/abm/adminsOrdersUi',
    appleFeStatusUpdate: 'restservices/admins/v1/abm/appleFeStatusUpdate',
    deviceStatusUpdate: 'restservices/admins/v1/deviceStatusUpdate',
    encryptImei: 'restservices/addp/v1/dashboard/encrypt',
    getcarekmedetails: 'restservices/admins/v1/kme/adminOrdersKME',
    getkmeuidetails: 'restservices/admins/v1/kme/uidetails',
    getcareztedetails: 'restservices/admins/v1/zte/adminOrdersZTE',
    getdeviceTrackingData: 'restservices/admins/v1/tracking',
    // getcareFeDetails: 'restservices/admins/v1/query/default/ABMOrgIDValidation', //feList
    //sendToAppleFeRequest: 'restservices/admins/v1/abm/facilitatedEnrollment',
    sendToAppleFeRequest: 'restservices/apple/abm/facilitatedEnrollment',
    getcareDeviceEnrollmentDetails: 'restservices/admins/v1/abm/adminsPendingABMTransaction',
    revisenotificationsettings: 'restservices/addp/v1/account/revisenotificationsettings',
    changeorgid:'/restservices/addp/v1/account/setup/changeorgid',
    enrollExistingDevice:'restservices/addp/v1/account/enrollexistingdevices',
    getBulkSchedulerRunTimeUrl:'restservices/admins/v1/abm/getSchedulerTriggeredDetails',
    getcareDmpWhiteistFans:'/restservices/admins/v1/query/default/DMPWhitelistFans', // dmpwhitelistfans
    saveDmpwhitelist: '/restservices/admins/v1/cms/default',
    deleteGroup: 'restservices/addp/v1/dashboard/deleteGroup',
    getInquireFanDetails: 'restservices/addp/v1/account/inquireFanDetails',
    getInquireProfile: 'restservices/addp/v1/dashboard/profilesummary',
    abmfeDepResellerId: '6FFA140',
    zteResellerId: '261789095',
    kmeResellerId: '6004067397',
    accessoriesLink: 'https://test12-www.wireless.att.com/business/shop/shop_cru_home.jsp?fromNewAccessoryPage=false&_requestid=3927',
    getLoginHistory: 'restservices/sapmp/v1/profile/loginInfo',
    logoutHistory: 'restservices/sapmp/v1/profile/logoutInfo',
    validateUserEmail:'restservices/sapmp/v1/profile/validateCustomerEmail'
  },
  'prod': {
    useMock: false,
    ticketProductionUpdateURL: 'restservices/admins/v1/cms/default/Ticket',
    updateProfile: 'restservices/sapmp/v1/profile/updateProfile',
    ticketProductionURL: 'restservices/admins/v1/query/default/Ticket',
    ticketUpdateURL: 'restservices/admins/v1/cms/test/Ticket',
    ticketURL: 'restservices/admins/v1/query/test/Ticket',
    viewHeaders: 'restservices/sapmp/v1/profile/viewHeaders',
    validateUser: 'restservices/sapmp/v1/profile/validateUser',
    deviceCountSummary: 'restservices/addp/v1/dashboard/deviceCount',
    getSamsungId: 'restservices/v1/sapmp/accountmanagement/samsung/validate',
    samsungValidate: 'restservices/v1/sapmp/accountmanagement/samsung/validate',
    zteIdValidate: 'restservices/v1/sapmp/accountmanagement/google/validate',
    appleOrgValidate: 'restservices/v1/sapmp/accountmanagement/apple/validate',
    tranIdValidate: 'restservices/v1/sapmp/accountmanagement/apple/checkTransactionStatus',
    createZtpAccount: 'restservices/v1/sapmp/accountmanagement/google/create',
    initialUrl: 'assets/contents/initailsignup/initialsignup.json',
    mdmDetails: 'restservices/v1/sapmp/accountmanagement/product',
    catalogEfotaForm: 'restservices/edit/v1/efotaenrollment/',
    fivegEnrollmentUrl: 'restservices/addp/v1/account/5genrollment/request',
    enrollDetails: 'assets/contents/enrollmentTool/enrollmentTool.json',
    productConfiguratorDetails: 'assets/mock/productConfigurator.json',
    fandetails: 'assets/mock/fan.json',
    cartUrl: 'assets/mock/cartService.json',
    bandetails: 'restservices/sapmp/v1/checkout/billing/getBansByFan/',
    ctndetails: 'restservices/sapmp/v1/checkout/billing/getCtnsByBan/',
    configurationUrl: 'assets/mock/configurations.json',
    validateCartUrl: 'restservices/sapmp/v0.5/cart/validate/',
    gridDataUrl: 'assets/mock/mockgriddata.json',
    prodLicense: 'assets/mock/productlisence.json',
    createUserUrl: 'assets/mock/createUser.json',
    profilesPageSize: 100,
    ctnPageSize: 45,
    homePageUrl: 'assets/cms/homePage.json',
    homePageFirstNetUrl: 'assets/cms/homePageFirstNet.json',
    homePageCms: 'restservices/cms/v1/document/home',
    contactdetails: 'assets/cms/contact.json',
    fncontactdetails: 'assets/cms/contact_fn.json',
    xmlUrl: 'assets/xml/premierxml.xml',

    // Catalog
    catalogServiceUrl: 'restservices/sapmp/v1/catalog/productDetails/products/' + ENV_PORTAL_DOMAIN + '/',
    // catalogServiceUrl: 'restservices/sapmp/v1/catalog/productDetails/products/',
    catalogColumnCount: '3', // TODO: Need to confirm with developer
    pricingupdate: 'restservices/sapmp/v1/catalog/products/priceDetails/',
    cartServiceUrl: 'restservices/sapmp/v1/cart/addCart',
    productSpecificationUrl: 'restservices/sapmp/v1/catalog/products/configurations',
    productTncUrl: 'restservices/sapmp/v1/catalog/products/tnc/' + ENV_PORTAL_DOMAIN + '/',
    changeProductUrl: 'restservices/sapmp/v1/catalog/products/priceDetails/expressCheckout',
    getPricingUpdateForDCMcode: 'restservices/sapmp/v1/catalog/products/priceDetails/manageProduct',

    // Subcription Service
    getBanUrl: 'restservices/sapmp/v1/company/accountList/',
    getCtnUrl: 'restservices/sapmp/v1/company/subscriptionList/',

    subscriptionUrl: 'restservices/sapmp/v1/companies/{companyid}/inventory/service?serviceType=browseProduct',
    manageLicensesUrl: 'restservices/sapmp/v1/companies/{companyid}/inventory/service',
    setUpdateUrl: 'restservices/sapmp/v1/companies/inventory/service/',
    ValidateChangeProduct: 'restservices/sapmp/v1/companies/{companyid}/inventory/service?serviceType=changeProduct&billingClientId=',
    premierUrl: 'restservices/sapmp/v1/premier/premierRedirection/',
    addUserUrl: 'restservices/sapmp/v1/companies/{companyid}/employees/addUser',
    bulkAssignUnAssignUrl: 'restservices/sapmp/v1/companies/',
    ctnValidationUrl: 'restservices/sapmp/v1/companies/{companyid}/inventory/service',
    permissionUrl: 'restservices/sapmp/v1/permissions/',
    tokenGenerationUrl: 'restservices/sapmp/v1/profile/tokengeneration/',
    userServiceUrl: 'restservices/sapmp/v1/user/',
    authTokenServiceUrl: 'restservices/sapmp/v1/user/login/',
    submitConfirmOrder: 'restservices/sapmp/v1/cart/order/',
    cspGroupValidationUrl: 'restservices/sapmp/v0.5/user/validateCSPGroup/',
    loggerServiceUrl: 'restservices/sapmp/v0.5/catalog/products/logging/',
    timeOut: '8000',
    getUserInfo: 'assets/mock/users.json',
    userSummary: 'assets/mock/usersummary-',
    singleProductUrl: 'restservices/sapmp/v1/companies/',
    userEdit: 'restservices/sapmp/v1/companies/',
    getAssignUnassignProductDetails: 'api/v1/companies/',
    userRemove: 'restservices/sapmp/v1/companies/',
    getManageUserCtnUrl: 'restservices/sapmp/v1/companies/',
    mockGridDataUrl: 'assets/mock/mock-griddata-page.json',
    getUserSearch: 'restservices/sapmp/v1/companies/',
    productLicenseUrl: 'restservices/sapmp/v1/companies/',
    unAssignUrl: 'restservices/sapmp/v1/companies/',
    profilePerm: 'restservices/sapmp/v1/profile/profileAndPermsInfo',
    profilePermAdmin: 'restservices/sapmp/v1/profile/profileAndPermsInfoAdmin',
    bulkUploadServiceUrl: 'restservices/sapmp/v1/company/file/upload',
    getProductAndPriceDetailsFromCSI: 'restservices/sapmp/v1/company/inquireMobileProductsOrder',
    getStatsTops: 'restservices/sapmp/v1/companies/{companyid}/top/{offercount}?breakdown=false',
    getStatsUsers: 'restservices/sapmp/v1/companies/{companyid}/stats',
    getStatsReport: 'restservices/sapmp/v1/company/file/download/userSummaryReport',
    getPricingForOwnedProduct: 'restservices/sapmp/v1/company/inquireMobileProductsOrder',
    bulkReviewUrl: 'restservices/sapmp/v1/companies/{companyId}/employees/bulk',
    getProductFanCtnDetails: 'assets/mock/manage_users.json',
    searchUsersUrl: 'restservices/sapmp/v1/companies/',
    cartOrderUrl: 'restservices/sapmp/v1/cart/order/modify/modifyOrder',
    changeCartOrderUrl: 'restservices/sapmp/v1/cart/order/',
    tokenRefresh: 'restservices/sapmp/v1/profile/refresh',
    haloAuthenticateUrl: 'restservices/sapmp/v1/profile/verifylogin',
    validateFanUrl: 'restservices/sapmp/v1/cart/addCart',
    priceDetailUrl: 'restservices/sapmp/v1/catalog/products/modifyProduct/priceDetails',
    WelcomeUrl: 'assets/contents/Welcome/welcome.json',
    faqServiceUrl: 'restservices/addp/v1/faqservice/getAll',
    settingsFormData: 'assets/mock/settingsFormData.json',
    faqServiceUrlMock: 'assets/mock/Faq/faqService.json',
    settingsFormConfig: 'assets/mock/formConfig.json',
    getFANList: 'restservices/addp/v1/account/summary',
    getprofileList: 'restservices/addp/v1/account/settings',
    getAppList: 'restservices/addp/v1/account/applications',
    getTNC: 'restservices/addp/v1/account/configuration/tnc',
    submitSignup: 'restservices/addp/v1/cart/signup-setup',
    submitGroup : 'restservices/addp/v1/dashboard/groupingImeis',
    updateGroupName: 'restservices/addp/v1/dashboard/updateGroup',
    getGroupDevices: 'restservices/addp/v1/dashboard/getDevicesGroups',
    getManageGroupsUrl:'restservices/addp/v1/dashboard/manageGroups',
    submitSignupInProgress: 'restservices/addp/v1/cart/signupinprogress',
    submitCancelParticipation: 'restservices/addp/v1/cart/cancel',
    cancelOEMUrl: 'restservices/addp/v1/cart/canceloem',
    createProfile: 'restservices/addp/v1/account/setup',
    updateProfileName: 'restservices/addp/v1/account/profiles',
    getFANListMock: ['assets/mock/signup/accounts/initialSignupFANList.json',
      'assets/mock/signup/accounts/allFANList.json',
      'assets/mock/signup/accounts/newNRevisedFANList.json',
      'assets/mock/signup/accounts/onlyRevisedFANList.json'],
    profilePermissionUrl: 'assets/mock/getProfile_Read_NoFAN.json',
    learnPageUrl: 'assets/mock/learnPage.json',
    profileListUrl: ['assets/mock/signup/settings/profileListLT20.json',
      'assets/mock/signup/settings/profileListGT20.json'],
    gridAppDataUrl: 'assets/mock/signup/applications/getappdetail.json',
    getProfileUrl: 'assets/mock/getprofiledetail.json',
    profilePermMock: ['assets/mock/profilePerm/readOnly.json',
      'assets/mock/profilePerm/partial.json',
      'assets/mock/profilePerm/full.json',
      'assets/mock/profilePerm/none.json'],
    fanSignupStatusUrl: ['assets/mock/fanSignedUpStatus/all.json',
      'assets/mock/fanSignedUpStatus/some.json',
      'assets/mock/fanSignedUpStatus/none.json'
    ],
    manageInventoryPageUrl: 'assets/mock/manageInventory/manageInventory.json',
    deviceDeploymentSummaryUrl: 'assets/mock/deployment_status_list.json',
    companyFanStatusUrl: 'assets/mock/company_fan_status.json',
    appleCertificateUrl: 'assets/mock/appleCertificateStatus.json',
    devicesSummaryMockUrl: 'assets/mock/devicesSummary.json',
    devicesSummaryUrl: 'restservices/addp/v1/dashboard/devices',
    ctnDetailsMockUrl: 'assets/mock/manageInventory/mockCtnDetails.json',
    ctnDetailsUrl: 'restservices/addp/v1/dashboard/ctninfo',
    ctnUpdateUrl: 'restservices/addp/v1/account/ctnUpdate/request',
    ctnNumberUrl: 'assets/mock/ctnNumber/ctnNumbers.json',
    imeiNumberUrl: 'assets/mock/imeiNumber/imeiNumbers.json',
    messageFormJson: 'assets/mock/messageForm.json',
    fanProfileUrl: 'restservices/addp/v1/dashboard/profileinfo',
    singleFanProfileUrl: 'assets/mock/singleFanProfile/fanDetails.json',
    dashboardSummary: 'restservices/addp/v1/dashboard/accountsummary',
    triggerActiveFans: 'restservices/addp/v1/dashboard/dataload',
    manyFanProfileUrl: 'assets/mock/singleFanProfile/manyFanDetails.json',
    sendSMSFanList: 'assets/mock/sendSMSFanMock.json',
    sendSmsMockJson: 'assets/mock/sendSmsCtnMock.json',
    notificationClient:'restservices/addp/v1/notificationservice/efotaReportRequestEmail',
    notificationServiceForm: 'restservices/addp/v1/notificationservice/form',
   sendSMSUrl: 'restservices/addp/v1/notificationservice/manageSms',
    abridgedList: 'assets/mock/abridgedFANList.json',
    notificationsUrlMock: 'assets/mock/notifications-alerts.json',
    notificationsUrl: 'restservices/addp/v1/notification/alert/',
    contentUrl: {
      signup: {
        accounts: 'assets/contents/signup/accounts.json',
        settings: 'assets/contents/signup/settings.json',
        applications: 'assets/contents/signup/applications.json',
        startdate: 'assets/contents/signup/startdate.json',
        review: 'assets/contents/signup/review.json',
        confirm: 'assets/contents/signup/confirm.json'
      },
      sendSMS: {
        page: 'assets/contents/sendSMS/message.json',
        modal: 'assets/contents/sendSMS/message-modal.json'
      },
      manageInventory: {
        manageInventoryPageUrl: 'assets/contents/manageInventory/manageInventory.json',
        deviceInventory: 'assets/contents/manageInventory/deviceInventory.json',
        ctnViewData: 'assets/contents/manageInventory/viewCtnPageData.json',
        deviceLockWipeDetailsUrl: 'assets/contents/manageInventory/deviceLockWipe.json',
        deviceStatusUrlMock: 'assets/contents/manageInventory/deviceLockStatus.json',
        deviceStatusUrl: 'restservices/addp/v1/device',
        getUpdatedCtnDetailsUrlMock: 'assets/contents/manageInventory/updatedCtnDetails.json'
      },
      dashboard: {
        dashboardData: 'assets/contents/dashboard/dashboardData.json'
      },
      applecertificate: {
        info: 'assets/contents/appleCertificate/info.json',
        upload: 'assets/contents/appleCertificate/upload.json'
      },
      cancelParticipation: {
        cancel: 'assets/contents/cancelParticipation/cancel/cancel.json',
        review: 'assets/contents/cancelParticipation/review/review.json',
        confirm: 'assets/contents/cancelParticipation/confirm/confirm.json',
      }
    },
    deviceInventoryDetailsUrl: 'assets/mock/deviceInventory/deviceInventoryDetails.json',
    getProfileStatusUrl: 'restservices/addp/v1/dashboard/deviceinventory',
    getProfileStatusMockUrl: 'assets/mock/deviceInventory/getProfileStatus.json',
    getFanStatusSummarymock: ['assets/mock/dashboard/initialSignup.json',
      'assets/mock/dashboard/signupInProgress.json',
      'assets/mock/dashboard/errorInSignup.json',
      'assets/mock/dashboard/awaitingSetup.json',
      'assets/mock/dashboard/setupInProgress.json',
      'assets/mock/dashboard/setupCompleted.json',
      'assets/mock/dashboard/deviceEnrollInProgress.json',
      'assets/mock/dashboard/deviceEnrollError.json',
      'assets/mock/dashboard/multiFanEnrolled.json',
      'assets/mock/dashboard/singleFanEnrolled.json'
    ],
    getAppleSummaryMock: ['assets/mock/apple-certificate/notInstalled.json',
      'assets/mock/apple-certificate/installed.json',
      'assets/mock/apple-certificate/expired.json',
      'assets/mock/apple-certificate/processing.json'],
    getAppleSummary: 'restservices/addp/v1/apple/inquire',
    generateCSR: 'restservices/addp/v1/apple/csr',
    deleteAppleCertificate: 'restservices/addp/v1/apple/delete',
    uploadAppleCertificate: 'restservices/addp/v1/apple/upload',
    getReportRequestUrl: 'restservices/addp/v1/report/snapshot/all',
    getReportRequestOEMUrl: 'restservices/addp/v1/report/snapshot/reportByFan',
    efotaRetrieveReport: 'restservices/addp/v1/report/efota/retrieveReport',
    efotaUpdateReport: 'restservices/addp/v1/report/efota/updateReport',
    efotaEnrollAccount: '/restservices/addp/v1/account/efota/signup',
    efotaGetReportFile: 'restservices/addp/v1/report/efota/getReportAttachment/',
    efotaChangeRequests: 'restservices/addp/v1/account/efota/getChangeRequests',
    efotaChangeRequest: 'restservices/addp/v1/account/efota/changeRequest',
    efotaAdminChangeRequests: 'restservices/admins/v1/query/default/Ticket',
    efotaUpdateChangeRequest: 'restservices/admins/v1/cms/default/Ticket/',
    efotaDisconnectAccount : 'restservices/admins/v1/efota/disconnect/',
    efotaEmailReport: 'restservices/addp/v1/report/efota/emailReportAttachment',
    efotaEnrollments: 'restservices/admins/v1/query/default/efotaenrollment',
    getTransactionReportRequestUrlMock: 'assets/mock/mockReportSuccess.json',
    getTransactionReportRequestUrl: 'restservices/addp/v1/report/transaction/',
    getReportPageConfigUrl: 'assets/mock/reportPageConfig.json',
    getCTN: 'restservices/addp/v1/report/validate/fan',
    getCarePageConfigUrl: 'assets/mock/care/carePageConfig.json',
    submitCareSelectedParticipation: 'lic/addp/v1/Care/submit',
    getSearchFanPageConfigUrl: 'assets/mock/care/searchFanConfig.json',
    getFanSearchFanDetails:'restservices/edit/v1/efotaenrollment/',
    getFanDetails: 'restservices/admins/v1/cms/default/efotaenrollment/',
    updateEnrollStatus: 'restservices/admins/v1/efota/default/efotaenrollment/',
    getAllFanDetails:'restservices/edit/v1/efotaenrollment',
    careUserServiceUrl: 'restservices/addp/v1/licservice/inquire/profile',
    getSupportDocument: 'restservices/addp/v1/faqservice/supportArticle/',
    getSupportDocumentMock: ['assets/mock/manageInventory/supportLock.json',
      'assets/mock/manageInventory/supportWipe.json',
      'assets/mock/manageInventory/supportLock.json'
    ],
    careAuthTokenServiceUrlMock: 'assets/mock/care/auth.json',
    careUserProfileUrlMock: 'assets/mock/care/userProfile.json',
    careAuthTokenWithoutFanIdServiceUrlMock: 'assets/mock/care/auth.json',
    careMultiFanMock: 'assets/mock/care/multifan.json',
    careSearchFanUrlMock: 'assets/mock/care/verify.json',
    careUserProfileUrl: 'restservices/addp/v1/licservice/aaf/inquire/permissions',
    careAuthTokenWithoutFanIdServiceUrl: 'restservices/addp/v1/licservice/csp/authenticate',
    careMultiFan: 'restservices/addp/v1/licservice/agreement/inquire/fans',
    careSearchFanUrl: 'restservices/addp/v1/licservice/fan/verify/',
    careUpdateEmail: 'restservices/addp/v1/licservice/customer/updateEmail',
    upgradeDeviceServiceUrl: 'service/addp/v1/fileuploadservice/upgradedevice/upload',
    getuploadfiles: 'restservices/admins/v1/abm/uidetails',
    getzteuploadfiles: 'restservices/admins/v1/zte/uidetails',
    getcareabmdetails: 'restservices/admins/v1/abm/adminsOrdersUi',
    appleFeStatusUpdate: 'restservices/admins/v1/abm/appleFeStatusUpdate',
    deviceStatusUpdate: 'restservices/admins/v1/deviceStatusUpdate',
    encryptImei: 'restservices/addp/v1/dashboard/encrypt',
    getcarekmedetails: 'restservices/admins/v1/kme/adminOrdersKME',
    getkmeuidetails: 'restservices/admins/v1/kme/uidetails',
    getcareztedetails: 'restservices/admins/v1/zte/adminOrdersZTE',
    getdeviceTrackingData: 'restservices/admins/v1/tracking',
    // getcareFeDetails: 'restservices/admins/v1/query/default/ABMOrgIDValidation', //feList
    //sendToAppleFeRequest: 'restservices/admins/v1/abm/facilitatedEnrollment',
    sendToAppleFeRequest: 'restservices/apple/abm/facilitatedEnrollment',
    getcareDeviceEnrollmentDetails: 'restservices/admins/v1/abm/adminsPendingABMTransaction',
    revisenotificationsettings: 'restservices/addp/v1/account/revisenotificationsettings',
    changeorgid:'/restservices/addp/v1/account/setup/changeorgid',
    enrollExistingDevice:'restservices/addp/v1/account/enrollexistingdevices',
    getBulkSchedulerRunTimeUrl:'restservices/admins/v1/abm/getSchedulerTriggeredDetails',
    getcareDmpWhiteistFans:'/restservices/admins/v1/query/default/DMPWhitelistFans', // dmpwhitelistfans
    saveDmpwhitelist: '/restservices/admins/v1/cms/default',
    deleteGroup: 'restservices/addp/v1/dashboard/deleteGroup',
    getInquireFanDetails: 'restservices/addp/v1/account/inquireFanDetails',
    getInquireProfile: 'restservices/addp/v1/dashboard/profilesummary',
    abmfeDepResellerId: '722D390',
    zteResellerId: '1907311204',
    kmeResellerId: '9942991583',
    accessoriesLink: 'https://www.wireless.att.com/business/shop/shop_cru_home.jsp?fromNewAccessoryPage=false&_requestid=3666',
    getLoginHistory: 'restservices/sapmp/v1/profile/loginInfo',
    logoutHistory: 'restservices/sapmp/v1/profile/logoutInfo',
    validateUserEmail:'restservices/sapmp/v1/profile/validateCustomerEmail'
  }
};